;(function($){

    function Prospectus_agenda() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });        

        if($("#modal-prospectus-agenda").length > 0) {
            
            $("#modal-prospectus-agenda").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();
                    _.getUsers(); 
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    var users = "";

                    users = '<div class="row">' +     
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="users_id">Usuário</label>' +
                                '<select name="users_id" id="users_id" disabled></select>' +
                            '</div>'+
                        '</div>'+                           
                   '</div>';

                    _.html = '<form id="form-prospectus-agenda" enctype="multipart/form-data">'+
                    users +
                    '<div class="row">' +
                        '<div class="col-lg-8  col-md-8  col-sm-8 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="date">Data</label>' +
                                '<input type="date" id="date" name="date">' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="time">Hora</label>' +
                                '<input type="time" id="time" name="time">' +
                            '</div>'+
                        '</div>'+                            
                   '</div>'+
                     '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="text_prospectus_agenda">Observações</label>' +
                                '<textarea name="text_prospectus_agenda" id="text_prospectus_agenda" rows="5"></textarea>' +
                                '<script src="'+$("#app_url").val()+'/vendor/ckeditor/ckeditor.js"></script>'+
                                '<script>'+
                                    'CKEDITOR.replace("text_prospectus_agenda", {'+
                                    'toolbar: ['+
                                        '{ name: "document", items: [ "Print"] },'+
                                        '{ name: "clipboard", items: [ "Undo", "Redo" ] },'+
                                        '{ name: "styles", items: [ "Format", "Font", "FontSize" ] },'+
                                        '{ name: "colors", items: [ "TextColor", "BGColor" ] },'+
                                        '{ name: "align", items: [ "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },'+
                                        '"/",'+
                                        '{ name: "basicstyles", items: [ "Bold", "Italic", "Underline", "Strike", "RemoveFormat", "CopyFormatting" ] },'+
                                        '{ name: "links", items: [ "Link", "Unlink" ] },'+
                                        '{ name: "paragraph", items: [ "NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote" ] },'+
                                        '{ name: "insert", items: [ "Image", "Table" ] },'+
                                        '{ name: "tools", items: [ "Maximize" ] },'+
                                        '{ name: "editing", items: [ "Scayt" ] }'+
                                    '],'+
                                    'filebrowserImageUploadUrl :"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'",'+
                                    'uploadUrl:"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'&json",'+
                                    'extraPlugins:"uploadimage",'+
                                    'extraAllowedContent: "h3{clear};h2{line-height};h2 h3{margin-left,margin-top}",'+
                                    'height: 150,'+
                                    'removeDialogTabs: "image:advanced;link:advanced"'+
                                '});'+
                                '</script>' +
                            '</div>'+
                        '</div>'+                             
                   '</div>'+
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +  
                                '<input type="hidden" id="prospectus_contacts_id" name="prospectus_contacts_id" value="'+_.prospectus_contacts_id+'">' +                                                 
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != "") {
                        $('#modal-prospectus-agenda').iziModal('setTitle', '<i class="fa fa-calendar" aria-hidden="true"></i> Agendamento');
                        $("#modal-prospectus-agenda .content").html(_.html);

                        _.myForm = $("#form-prospectus-agenda").validate({
                            rules: {
                                date: { required: true },   
                                time: { required: true },   
                                text_prospectus_agenda: { required: true },                            
                            },
                            messages: {
                                date: { required: "Campo Obrigatório" },
                                time: { required: "Campo Obrigatório" },
                                text_prospectus_agenda: { required: "Campo Obrigatório" }
                            },
                            invalidHandler: function(e) {
                                
                                swal({
                                    title: "Atenção!",
                                    text: "Preencha todos os campos.",
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "OK!",
                                    closeOnConfirm: true
                                });

                            },
                            submitHandler: function( form ) {

                                for(instance in CKEDITOR.instances) {
                                    CKEDITOR.instances[instance].updateElement();
                                }

                                $("#form-prospectus-agenda .btn-send").html("Enviando...");
                                
                                $.ajax({
                                    type: "POST",
                                    url: _.API + "prospectos/agendamentos",
                                    cache: false,
                                    contentType: false,
                                    processData: false,
                                    data: new FormData(form),
                                    success: function(result)
                                    {
                                        $("#form-prospectus-agenda .btn-send").html("Enviar");

                                        form.reset();

                                        $('#modal-prospectus-agenda').iziModal('close'); 

                                        swal({
                                            title: result.message,
                                            text: "Click no botão para fechar!",
                                            type: "success",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: false
                                        }).then(function() {
                                          location.reload();
                                        });                                        
                                    },
                                    error: function(response) {
                                        var errors = $.parseJSON(response.responseText);
                                        $("#form-prospectus-agenda .btn-send").html("Enviar");
                                        
                                        swal({
                                            title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                            text: "Click no botão para fechar!",
                                            type: "warning",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: true
                                        });

                                        $myForm.showErrors(errors);
                                        
                                        
                                    }
                                });
                            }
                        });
                    }               
                },
                onClosed: function() {
                    _.uri                    = null;
                    _.prospectus_contacts_id = null;
                    _.users_id               = null;
                    _.html                   = null;
                    _.myForm                 = null;
                    $("#modal-prospectus-agenda .content").html("");
                    $('#modal-prospectus-agenda').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-create-prospectus-agenda").on("click", function(e){
            e.preventDefault();
            _.prospectus_contacts_id  = $(this).data('prospectus');
            _.users_id                = $(this).data('user');
            $('#modal-prospectus-agenda').iziModal('open');           
        });
    }    

    Prospectus_agenda.prototype.getUsers = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/usuarios", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
                var selectedStatus = (_.users_id == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#users_id").attr('disabled', false).html(html);
            $("select#users_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 

   	new Prospectus_agenda();

}(jQuery));
 
 
 
 
